<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules"  label-position="top">
                <Row :gutter="32">
                    <Col span="24">
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 报价信息</template>
                            <FormItem label="报价金额" prop="quote_money">
                                <Input v-model="Forms.quote_money" type="number" class="width-50" clearable placeholder="如：10000" />
                            </FormItem>
                            <FormItem label="报价清单" prop="quote_file">
                                <Input v-model="Forms.quote_file" disabled>
                                    <template #append>
                                        <div class="f-center">
                                            <Upload
                                                :show-upload-list="false"
                                                :action="upload_url"
                                                :headers = "{'token': $store.state.token}"
                                                :format="['xls','xlsx','rar','zip','doc','docx','txt','docx','jpg','jpeg','png','pdf']"
                                                :max-size="50 * 1024"
                                                :on-success="handleSuccess"
                                                :on-format-error="handleFormatError"
                                                :on-exceeded-size="handleMaxSize">
                                                <a href="javascript:void(0);" class="text-primary"><Icon type="md-cloud-upload" />上传</a>
                                            </Upload>
                                            <Divider type="vertical" />
                                            <a href="javascript:void(0);" @click="FileDelete()" class="text-danger"><Icon type="md-trash" />删除</a>
                                            <Divider type="vertical" />
                                            <a href="javascript:void(0);" @click="FileDownload(Forms.quote_file)" class="text-violet"><Icon type="md-download" />下载</a>
                                        </div>
                                    </template>
                                </Input>
                            </FormItem>
                            <FormItem label="报价清单说明" prop="quote_desc">
                                <Input v-model="Forms.quote_desc" type="textarea" :rows="8" clearable placeholder="报价说明" />
                            </FormItem>
                        </Card>
                    </Col>
                </Row>
                <Row :gutter="32">
                    <Col span="24">
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 项目信息</template>
                            <DescriptionList class="show-description-title" title="" :col="2"  layout="vertical">
                                <Description term="项目名称：">
                                    {{detail.name}}
                                </Description>
                                <Description term="项目类型：">
                                    <Tag>{{detail.type_name}}</Tag>
                                </Description>
                                <Description term="项目预算：">
                                    <Tag color="green" v-if="detail.budget_money">{{detail.budget_money}}</Tag>
                                </Description>
                                <Description term="项目周期：">
                                    <Tag color="orange" v-if="detail.project_cycle">{{detail.project_cycle}}</Tag>
                                </Description>
                                <Description term="甲方：">
                                    {{detail.company}}
                                </Description>
                                <Description term="联系人：">
                                    {{detail.customer_real_name}}
                                </Description>
                                <Description term="联系电话：">
                                    {{detail.customer_mobile}}
                                </Description>
                                <Description term="微信账号：">
                                    {{detail.customer_wechat}}
                                </Description>
                                <Description term="负责人：">
                                    {{detail.head_name}}
                                </Description>
                                <Description term="项目资料：">
                                    <Tag v-if="detail.project_file" class="cursor" color="primary" @click="FileDownload(detail.project_file)">点击下载项目资料</Tag>
                                    <small v-else>未上传</small>
                                </Description>
                            </DescriptionList>
                        </Card>
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 项目说明</template>
                            <div class="textarea-wrap">{{detail.project_desc}}</div>
                        </Card>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">确认报价</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {quoteProject, getProjectContentDetail} from "@/apis/project";

export default {
    name: 'ProjectQuote',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '项目报价',
            isBox : false,
            detail: [],
            upload_url : this.$uploadFileApi,
            site_url : this.$siteApi,
            Forms : {
                project_id: '',
                quote_money: '',
                quote_file: '',
                quote_desc: ''
            },
            Rules : {
                quote_money: [
                    { required: true, type: 'number',  message: '请输入报价金额', trigger: 'blur',  transform(value) { return parseFloat(value)}},
                    { type: 'number', min: 1, message: '项目报价必须大于等于1元', trigger: 'blur' }
                ]
            }
        }
    },
    methods: {
        /**
         功能：图片文件
         time: 2025/12/17 10:48
         **/
        FileDelete(){
            let that = this;
            that.Forms.quote_file = "";
        },
        /**
         功能：
         time: 2025/12/17 10:48
         **/
        handleSuccess(res){
            let that = this;
            if(res.code == 100){
                this.Forms.quote_file = res.data.url;
            }else{
                that.$Message.error({ background: true,duration:3, content: res.msg});
            }
        },
        /**
         功能：
         time: 2025/12/17 10:48
         **/
        handleFormatError(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '只支持 xls | xlsx | rar | zip | doc | docx | txt | jpg | jpeg | png 文件 ' });
            return false;
        },
        /**
         功能：
         time: 2025/12/17 10:48
         **/
        handleMaxSize(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '文件大小不能超出 50M' });
            return false;
        },
        /**
         功能：
         time: 2025/12/19 18:12
         **/
        FileDownload(url){
            let that = this;
            if(url){
                //下载文件
                const fileUrl = that.site_url + url; // 文件的URL地址
                const parts = fileUrl.split('/');
                const fileName = parts[parts.length - 1];
                const link = document.createElement('a');
                link.href = fileUrl;
                link.setAttribute('download', fileName);
                link.click();
            }else{
                that.$Message.error({ background: true,duration:3, content: '没有资料可下载'});
            }
        },
        /**
         功能：
         time: 2025/12/17 16:04
         **/
        GetDetail(project_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getProjectContentDetail(project_id).then(e => {
                that.detail = e.data;
                that.Forms.quote_money = e.data.quote_money ? e.data.quote_money : '';
                that.Forms.quote_file = e.data.quote_file ? e.data.quote_file : '';
                that.Forms.quote_desc = e.data.quote_desc ? e.data.quote_desc : '';
            })
        },
        /**
         功能：
         time: 2025/12/17 10:47
         **/
        show(project_id, name){
            this.isBox = true;
            this.title = name + ' - 项目报价';
            if(project_id){
                this.Forms.project_id = project_id;
                this.GetDetail(project_id);
            }
        },
        /**
         功能：
         time: 2025/12/20 09:24
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    quoteProject(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：
         time: 2025/12/20 11:54
         **/
        FormReset(){
            this.isBox = false;
            this.title = '项目报价';
            this.$refs['Forms'].resetFields();
            this.Forms.project_id = '';
            this.detail = [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
